<template>
  <div class="UserList" v-title data-title="用户列表">
    <!-- <div class="row pl5 pr5 pt5">
      <div class="col-6 pl3 pr3">
        <div @click="goNotice()" class="add bc-success-info ">
          公告
        </div>
      </div>
      <div class="col-6 pl3 pr3">
        <div @click="goData('/btn/info')" class="add bc-success-info ">
          按钮
        </div>
      </div>
      <div class="col-6 pl3 pr3">
        <div @click="exportData()" class="add bc-warn-info ">
          导出
        </div>
      </div>
      <div class="col-6 pl3 pr3">
        <div @click="goData('/stock/info/home')" class="add bc-warn-info ">
          库虾
        </div>
      </div>
      <div class="col-6 padding3">
        <div @click="goData('')" class="add" style="background: #ffc107;">
          访问量
        </div>
      </div>
      <div class="col-6 padding3">
        <div @click="goData('/AD/info/list')" class="add" style="background: #ffc107;">
          广告
        </div>
      </div>
      <div class="col-12 padding3">
        <div @click="goDetail()" class="add bc-primary-info ">
          添加用户
        </div>
      </div>
      <div class="col-6 padding3">
        <div @click="goData('/black/list/home')" class="add bc-primary-info ">
          黑名单
        </div>
      </div>
    </div> -->
    <!-- <van-field v-model="btnLink.price" label="点我报价" />
    <van-field v-model="btnLink.danb" label="平台担保" /> -->
    <!-- <van-loading v-if="loading" type="spinner" color="#1989fa"></van-loading> -->
    <div class="pt5"><van-button class="btn-common" plain="" type="info"
              @click="back">返回</van-button></div>
    <van-list
      v-model="loading"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :finished="finished"
      :finished-text="records.length > 10 ? '没有更多了' :''"
      @load="loadMore"
    >
      <div class="text-left pl3 pr3 pt5">
        <div class="row align-items-center pt7 pb5 pl3 pr3 line pos-rel"
          v-for="item in records"
          :key="item.id">
          <van-tag mark plain :type="item.type===3?'success':'primary'" class="user-tag">{{item.type===3?'合作单位':'报价商'}}</van-tag>
          <!-- <div class="user-tag">报价商</div> -->
          <div class="flex-1">
            <div class="row align-items-center">
              <div class="fc-suppl">店铺/公司：</div>
              <div class="col text-left text-ellipsis">
                {{item.companyName||item.storeName||'暂未填写'}}
              </div>
            </div>
            <div class="pt4 row align-items-center">
              <div class="fc-suppl">账号：</div>
              <div class="col pl7">{{item.username}}</div>
            </div>
            <div v-if="item.type===2" class="pt4 row align-items-center">
              <span class="fc-suppl">价格更新时间：</span>{{item.lastUpdateDate||'暂未发布报价'}}
            </div>
          </div>
          <div>
            <div v-if="item.type===2" class="pb1">
              <van-button type="info" plain size="small" @click="goSet(item)" class="btn-user">设置规则</van-button>
            </div>
            <van-button type="info" size="small" @click="goDetail(item)" class="btn-user">编辑用户</van-button>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import Vue from 'vue';
import { sendRequest, users } from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';
import config from '../../config';

export default Vue.extend({
  name: 'UserList',
  components: {},
  data() {
    return {
      loading: false,
      error: false,
      finished: false,
      size: 20,
      current: 0,
      total: 1,
      pages: 1,
      hasNext: true,
      records: [],
      btnLink: {

      },
    };
  },
  methods: {
    loadMore() {
      if (this.pages <= this.current) {
        return;
      }
      this.getData(this.current + 1);
    },
    getData(page = 1) {
      // console.log(this.loading);
      sendRequest(users, {
        current: page,
        size: this.size,
      }).then((res) => {
        const {
          total = 1, records = [], pages = 1, hasNext = false,
        } = res;
        // eslint-disable-next-line eqeqeq
        if (page == 1) {
          this.records = records || [];
        } else {
          this.records = this.records.concat(records || []);
        }
        this.total = total;
        this.pages = pages;
        this.hasNext = hasNext;
        this.current = page;
        if (!this.hasNext || (records || []).length < this.size || this.records.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
        this.error = true;
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    goDetail(e = {}) {
      storage.local.set('busername', e.username || '');
      if (e.id) {
        this.$router.push(`/user/edit/${e.type === 3 ? 'hzdw' : 'bjs'}/${e.id || ''}`);
      } else {
        this.$router.push('/user/home');
      }
    },
    goNotice(e = {}) {
      this.$router.push('/notice/info');
    },
    goData(url) {
      this.$router.push(url || '/data/info');
    },
    goSet(e = {}) {
      // storage.local.set('busername', e.username || '');
      this.$router.push(`/user/sync/rule/${e.id || ''}`);
    },
    exportData(e = {}) {
      this.$dialog.confirm({
        title: '确认',
        message: '确定立即下载当日报价信息吗？',
      }).then(() => {
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = `${config.DOWNLOAD_DOMAIN}/api/quote/report`;
        // 获取文件名
        // download 属性定义了下载链接的地址而不是跳转路径
        link.setAttribute('download', '今日报价.xlsx');
        document.body.appendChild(link);
        link.click();
      }).catch(() => {
        // on cancel
      });
    },
    back() {
      // this.$router.back();
      this.$router.push('/home');
    },
  },
  created() {
  },
});
</script>
<style scoped>
  .UserList {
    min-height: 100vh;
    background-color: #ffffff;
    font-size: 14px;
  }
  .title {
    padding: 20px 0;
    font-size: 20px;
  }
  .add {
    padding: 10px 0;
  }
  .van-cell {
    text-align: left;
    padding: 20px;
  }
  .btn-user {
    /* padding: 10px 10px!important; */
  }
  .user-tag {
    position: absolute;
    top: 1px;
    left: 0;
    /* width: 20px; */
  }
</style>
